export function ProviderSignature({ children }: { children: React.ReactNode }) {
  return (
    <p
      className="tw:border-b tw:border-stroke-tertiary tw:text-xl"
      style={{ fontFamily: "Apple Chancery, cursive" }}
    >
      {children}
    </p>
  );
}
